import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import MiljokontrollKommentarer from "./MiljokontrollKommentarer";

import { getMiljokontrollKommentarer } from "../../../../actions/miljokontrollerActions";

export default function MiljokontrollKommentarerContainer(props) {
  const dispatch = useDispatch();
  const miljokontrollKommentarer = useSelector(
    (state) => state.miljokontrollKommentarer,
  );
  const handleGetMiljokontrollKommentarer = useCallback(
    (miljokontrollId) => dispatch(getMiljokontrollKommentarer(miljokontrollId)),
    [dispatch],
  );

  return (
    <MiljokontrollKommentarer
      {...props}
      miljokontrollKommentarer={miljokontrollKommentarer}
      getMiljokontrollKommentarer={handleGetMiljokontrollKommentarer}
    />
  );
}
